import axios from 'axios'

let _ = require('lodash')

const apiUrl = process.env.VUE_APP_API_URL
const apiKey = process.env.VUE_APP_API_KEY

let h = {}

if (!_.isNil(apiKey)) {
  h = {
    "Content-Type": "application/json",
    "x-api-key": `${apiKey}`
  }
} else {
  h = {
    "Content-Type": "application/json"
  }
}

const apiCall = axios.create({
  baseURL: apiUrl,
  headers: h
})

export default apiCall

//Handle JWT Token
apiCall.interceptors.request.use(config => {
  let tokenJWT = localStorage.getItem('token')
  if (tokenJWT) {
    config.headers['Authorization'] = 'Bearer ' + tokenJWT;
  }
  return config
});

//Token Refresh
apiCall.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (401 === error.response.status) {
    let sessionExpired = true;
    localStorage.setItem('session', 'sessionExpired')
    if (sessionExpired) {
      location.href = '/logout'
    }
  }
});